import type { ReactNode } from 'react';
import { Group, createStyles } from '@mantine/core';

import { Text } from '~/domains/design-system/Text';

const NUMBER_SIZE = 24;

const useStyles = createStyles((theme) => ({
  number: {
    flexShrink: 0,
    width: NUMBER_SIZE,
    height: NUMBER_SIZE,
    borderRadius: theme.radius.xl,
    background: theme.colors.gray2[0],
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
}));

type NumberedRowProps = {
  number: number;
  align?: 'center' | 'flex-start';
  children: ReactNode;
};

export function NumberedRow({ number, align = 'center', children }: NumberedRowProps) {
  const { classes, theme } = useStyles();

  return (
    <Group noWrap align={align} spacing={theme.other.spacing._12}>
      <div className={classes.number}>
        <Text variant="label-small">{number}</Text>
      </div>
      <Text variant="body-medium">{children}</Text>
    </Group>
  );
}
